// extracted by mini-css-extract-plugin
export default {"deniedPageContainer":"hFOS_9fd","deniedCard":"ogBXM2Fh"};